import React, { Dispatch, SetStateAction, useState, FC } from 'react'
import FollowIcon from 'svg/follow.svg'
import FollowingIcon from 'svg/following.svg'
import FollowConnector, { ConnectorProps as FollowProps } from 'containers/Follow'
import { updateUserFollowApi } from 'apis/private/follow'
import AuthenticationConnect, {
  ConnectorProps as AuthenticationProps,
} from 'connectors/Authentication'
import AppConnector, { ConnectorProps as AppProps } from '../../connectors/App'
import classNames from 'classnames'
import { capitalizeString } from 'lib/helpers'
import styles from './Follow.module.scss'
import useQA from 'hooks/useQA'
import { UpdateFollowType } from '../../types'
type ArtistInfoProps = AppProps &
  FollowProps &
  AuthenticationProps & {
    showText?: boolean
    setFollowedUserArray: Dispatch<SetStateAction<Array<any>>>
    followedUserArray: ReadonlyArray<number>
  }

const Follow: FC<ArtistInfoProps> = (props: ArtistInfoProps) => {
  const {
    authenticated,
    openModal,
    userID,
    sessionUserID,
    artistID,
    fullName,
    showText,
    followedUserArray,
    setFollowedUserArray,
  } = props
  const [isFollowHovered, setIsFollowHovered] = useState(false)
  const myOwnAccount = sessionUserID === artistID
  const handleMouseEnter = () => setIsFollowHovered(true)
  const handleMouseLeave = () => setIsFollowHovered(false)
  const { testId } = useQA()

  const isArtistFollowed =
    authenticated && Array.isArray(followedUserArray) && followedUserArray.includes(artistID)

  const updateFollow = async ({
    userID,
    targetUserId,
    authenticated,
    following,
    openModal,
    callBack,
  }: UpdateFollowType) => {
    if (!authenticated) {
      openModal('login')
    }

    const apiResponse = await updateUserFollowApi({
      userID,
      targetUserId,
      following,
    })

    if (apiResponse) {
      callBack(targetUserId)
    }
  }

  const handleFollow = () => {
    if (!isArtistFollowed && window && window.dataLayer) {
      window.dataLayer.push({
        event: 'follow',
      })
    }

    updateFollow({
      userID,
      targetUserId: artistID,
      authenticated,
      following: !isArtistFollowed,
      openModal,
      callBack: () => {
        if (window && window.dataLayer) {
          if (!isArtistFollowed) {
            window.dataLayer.push({
              event: 'follow success',
            })
          } else {
            window.dataLayer.push({
              event: 'unfollow',
            })
          }
        }

        isArtistFollowed
          ? setFollowedUserArray(followedUserArray.filter((item) => item !== artistID))
          : setFollowedUserArray([...followedUserArray, artistID])
      },
    })
  }

  if (authenticated && myOwnAccount) {
    return null
  }

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={classNames(styles.followBox, {
        [styles.followBoxHovered]: isArtistFollowed && isFollowHovered,
      })}
    >
      <button
        onClick={handleFollow}
        className={classNames(styles.followBoxButton, {
          [styles.followBoxButtonShowText]: showText,
        })}
        {...testId('follow-button-box')}
        title={`${isArtistFollowed ? 'Unfollow' : 'Follow'} ${capitalizeString(fullName)}`}
        rel='nofollow'
      >
        {isArtistFollowed ? <FollowingIcon /> : <FollowIcon />}
        <p>{isArtistFollowed ? (isFollowHovered ? 'UNFOLLOW' : 'FOLLOWING') : 'FOLLOW'}</p>
      </button>
    </div>
  )
}

export default FollowConnector(AuthenticationConnect(AppConnector(Follow)))
